import dynamic from 'next/dynamic';
const InlineSVG = dynamic(() => import('./InlineSVG'));
export default InlineSVG;
